module.exports = __webpack_public_path__ + "static/media/CheckMark_Blue.74aa3a40.svg";